import request from '@/utils/request'
import store from '@/store'
// 2026-10-17：会员支付弹窗意向沿用可信身份拦截，手机号只由后端认证读取。
import {assertOrderIdentity,captureOrderIdentity,OrderIdentity} from '@/utils/orderContext'
export default {
  getDepositPdfSettings:()=>request({url:'customer/deposites/pdf/settings',method:'GET'}),
  recordMemberPurchaseInterest: (vipRoleTermId:number, identity:OrderIdentity) => {
    try{
      if(!Number.isSafeInteger(vipRoleTermId) || vipRoleTermId<=0) throw new Error('会员期限无效')
      assertOrderIdentity(identity,captureOrderIdentity())
      return request({url:'customer/memberPurchaseInterest',method:'POST',data:{vipRoleTermId,source:'web'},
        orderSubmissionIdentity:Object.freeze({...identity})} as any)
    }catch(error){return Promise.reject(error)}
  },
  // 2026-10-17：游客仅读取机构可销售会员参考目录，不暴露客户权益或支付信息。
  getMemberOffers: (orgId:number) => request({url:'land/memberOffers',method:'GET',params:{orgId}}),
  // 2026-09-08：当前认证客户按商品查询下载资格；客户端不提交客户身份、金额或扣次状态。
  // 2026-09-09：购物车使用批量会员资格，普通购买不授予其他规格或类型。
  getMemberDownloadBatch: (productIds:number[]) => request({url:'customer/memberDownloadEligibility',method:'POST',data:productIds}),
  getMemberDownloadEligibility: (productId:number) => request({url:'customer/memberDownloadEligibility',method:'GET',params:{productId}}),
  // 2026-08-24：会员升级目录、客户类型选择和网页可信支付统一读取VIP等级总控。
  getVipCatalog: () => {
    return request({
      url: 'customer/vip/catalog',
      method: 'GET'
    })
  },
  selectVipCustomerType: (customerTypeId: number) => {
    return request({
      url: 'customer/vip/customerType',
      method: 'POST',
      data: { customerTypeId }
    })
  },
  createMemberNativeIntent: (vipRoleTermId: number, requestId: string) => {
    return request({
      url: 'customer/memberPayment/native/intent',
      method: 'POST',
      data: { vipRoleTermId, requestId }
    })
  },
  getMemberPaymentStatus: (orderNumber: string) => {
    return request({
      url: `customer/memberPayment/intent/${encodeURIComponent(orderNumber)}`,
      method: 'GET'
    })
  },
  getMemberPaymentOrders: () => request({url:'customer/memberPayment/orders',method:'GET'}),
  resumeMemberNativeIntent: (orderNumber:string) => request({url:`customer/memberPayment/intent/${encodeURIComponent(orderNumber)}/native/resume`,method:'POST'}),
  saveAddress: (data: any) => {
    return request({
      url: 'customer/customerAddress',
      method: 'POST',
      data
    })
  },
  addFavorite: (data: any) => {
    return request({
      url: 'customer/favorite',
      method: 'POST',
      data
    })
  },
  
  saveCusNote: (note) => {
    return request({
      url: `customer/cusNotes`,
      method: 'POST',
      data:note
    })
  },
  saveCustomerNote: (data: any) => {
    return request({
      url: 'customer/customerNote',
      method: 'POST',
      data
    })
  },
  getOrgNote: () => {
    const orgId=store.getters.orgId
    return request({
      url: `customer/orgNote?orgId=${orgId}`,
      method: 'GET'      
    })
  },
  listShareCouponEnabled: (orgId:number) => request({url:'customer/listShareCouponEnabled',method:'GET',params:{orgId}}),
  recordListShareVisit: (orgId:number,referrerId:number,browserId:string) => request({url:'customer/listShareVisit',method:'POST',data:{orgId,referrerId,browserId}}),
  addFootprint: (data: any) => {
    if(store.getters.userInfo.id){
      return request({
        url: 'customer/footprint',
        method: 'POST',
        data
      })
    }
    
  },
  getMyfootprint: (data: any) => {
    return request({
      url: 'customer/myfootprint',
      method: 'POST',
      data
    })
  },
  resetPwd: (data: any) => {
    const orgId=store.getters.orgId
    return request({
      url: `land/resetPwd?phone=${data.phone}&password=${data.password}&code=${data.code}&orgId=${orgId}`,
      method: 'GET',
      data
    })
  },
  deleteFootprint:(id)=>{
    return request({
      url: `customer/footprint?id=${id}`,
      method: 'DELETE'
    })
  },
  addClient: (data: any) => {
    return request({
      url: 'land/addClient',
      method: 'POST',
      data
    })
  },
  getUserCount:(loginName)=>{
    // 2026-08-11：注册重名校验补充当前机构，保持与分店登录及机构级唯一键一致。
    const orgId=store.getters.orgId
    return request({
      url: `land/userCount?loginName=${encodeURIComponent(loginName)}&orgId=${orgId}`,
      method: 'GET'
    })
  },
  getFavorite:(cusId,prdId,productType?)=>{
    // 2026-08-11：收藏查询支持可选商品类型，精确区分同款版型与成衣定制收藏。
    const typeParam=productType===undefined?'':`&productType=${productType}`
    return request({
      url: `customer/favorite?customerId=${cusId}&productId=${prdId}${typeParam}`,
      method: 'GET'
    })
  },
  getFavorites:(cusId)=>{
    return request({
      url: `customer/favorites?customerId=${cusId}`,
      method: 'GET'
    })
  },
  getFavoritesWithImages:(cusId)=>{
    return request({
      url: `customer/favoritePrds?id=${cusId}`,
      method: 'GET'
    })
  },
  delFavorite:(id,type)=>{
    return request({
      url: `customer/favorite?id=${id}&productType=${type}`,
      method: 'DELETE'
    })
  },
  addAdvices: (data: any) => {
    return request({
      url: 'customer/advices',
      method: 'POST',
      data
    })
  },
  getAdvices: (id) => {
    return request({
      url: `customer/advices?customerId=${id}`,
      method: 'GET',
      
    })
  },
  savePayment: (data: any) => {
    return request({
      url: 'customer/savepayment',
      method: 'POST',
      data
    })
  },
  updateMemerOrderUrl: (orderNumber,url) => {
    return request({
      url: `customer/updateMemerOrderUrl?orderNumber=${orderNumber}&url=${encodeURIComponent(url)}`,
      method: 'GET',      
    })
  },
  cancelMemberOrder: (id) => {
    return request({
      url: `customer/cancelMemberOrder?id=${id}`,
      method: 'POST'
    })
  },
  setClientLevel: (id,levelId) => {
    return request({
      url: `customer/setClientLevel?id=${id}&level=${levelId}`,
      method: 'GET',
      
    })
  },
  getCustomerNoteCount: (customerId) => {
    return request({
      url: `customer/customerNoteCount?customerId=${customerId}`,
      method: 'GET',
      
    })
  },
  clientById: (customerId) => {
    return request({
      url: `customer/clientById/${customerId}`,
      method: 'GET',
      
    })
  },
  getGenewals: (customerId) => {
    return request({
      url: `customer/renewalsByCustomerId?customerId=${customerId}`,
      method: 'GET',
      
    })
  },
  // 2026-08-01 17:22：付款前由后端统一校验体验会员是否仍可购买，避免客户端写死等级 ID。
  // 2026-09-05：新版会员购买按真实VIP期限校验，保留旧等级参数兼容其它入口。
  checkMemberPurchaseEligibility: (levelId, vipRoleTermId?:number) => {
    return request({
      url: `customer/memberPurchaseEligibility?levelId=${levelId}${vipRoleTermId ? `&vipRoleTermId=${vipRoleTermId}` : ''}`,
      method: 'GET'
    })
  },
  getDepositeAmount: (customerId) => {
    return request({
      url: `customer/depositeAmount?customerId=${customerId}`,
      method: 'GET',
      
    })
  },
  // 2026-08-13：测试 C 端使用受限模拟充值接口，正式环境由后端硬拒绝且前端不会调用。
  testDeposite: (settingId, requestId) => {
    return request({
      url: `customer/testDeposite?settingId=${settingId}&requestId=${encodeURIComponent(requestId)}`,
      method: 'POST'
    })
  },
  // 2026-08-20：平台机构及 PayType=3 分店充值只提交后台档位和幂等请求号，其余字段由后端确定。
  createDepositPaymentIntent: (settingId, requestId) => {
    return request({
      url: 'customer/depositPayment/intent',
      method: 'POST',
      data: { settingId, requestId }
    })
  },
  // 2026-09-28：查单携带原幂等号供后端核验支付环境，兼容旧调用及分店充值路由。
  getDepositPaymentStatus: (orderNumber, requestId?:string) => {
    return request({
      url: `customer/depositPayment/intent/${encodeURIComponent(orderNumber)}${requestId ? `?requestId=${encodeURIComponent(requestId)}` : ''}`,
      method: 'GET'
    })
  },
  sendDepositeSMS: (data) => {
    return request({
      url: `customer/sendDepositeSMS`,
      method: 'POST',
      data
    })
  },
  sendDepositeOrderSMS: (data) => {
    return request({
      url: `customer/sendDepositeOrderSMS`,
      method: 'POST',
      data
    })
  },
  getDeposites: (customerId) => {
    return request({
      url: `customer/deposites?customerId=${customerId}`,
      method: 'GET',
      
    })
  },
  
  createOrder: (data) => {
    return request({
      url: `customer/createOrder`,
      method: 'POST',
      data
    })
  },
  createWechatBindingState:()=>request({url:'customer/wechatBindingState',method:'POST'}),
  unbindAccount: (id) => {
    return request({
      url: `customer/unbindAccount?id=${id}`,
      method: 'DELETE',
      
    })
  },
  getAddress: (customerId) => {
    return request({
      url: `customer/customerAddress/${customerId}`,
      method: 'GET',
      
    })
  },
  setDefault: (id,cusid) => {
    return request({
      url: `customer/setDefault?id=${id}&cusid=${cusid}`,
      method: 'GET',
      
    })
  },

  getDefaultAddress: (customerId) => {
    return request({
      url: `customer/defaultAddress/${customerId}`,
      method: 'GET',
      
    })
  },
  getSingleAddress: (id) => {
    return request({
      url: `customer/address/${id}`,
      method: 'GET',
      
    })
  },
  getMyNotesByCustomerId: (id) => {
    return request({
      url: `customer/myNotesByCustomerId?customerId=${id}`,
      method: 'GET',
      
    })
  },
  getMyValideNotesByCustomerId: (id) => {
    return request({
      url: `customer/myValideNotesByCustomerId?customerId=${id}`,
      method: 'GET',
      
    })
  },
  takeNote: (id,statu) => {
    return request({
      url: `customer/takeNote?id=${id}&statu=${statu}`,
      method: 'GET',
      
    })
  },
  noteRead: (id) => {
    return request({
      url: `customer/cusNoteRead?customerId=${id}`,
      method: 'GET',
      
    })
  },
  delCustomerAddress: (id) => {
    return request({
      url: `customer/customerAddress?id=${id}`,
      method: 'DELETE',
      
    })
  },
  updateClientInfo: (data) => {
    return request({
      url: `customer/updateClientInfo`,
      method: 'POST',
      data
    })
  }
}
